/* The dialog rhythm (design/50-components.md "The rhythm inside a dialog"): the title takes the
   `2xl` region gap to the body, and the body's paragraphs sit `xl` apart. */
.dialog {
  display: flex;
  flex-direction: column;
  gap: var(--space__2xl);
}

.body {
  display: flex;
  flex-direction: column;
  gap: var(--space__xl);
}

/* The release and the holdings source are one group of facts, closer to each other than to the
   legal terms below them. */
.sources {
  display: flex;
  flex-direction: column;
  gap: var(--space__sm);
}
